import React from "react";
import { MentionableUserFragment } from "__generated__/graphql";
import { getEmployeeDisplayName } from "employee/helpers/getEmployeeDisplayName";

interface IDisplayTemplateProps {
  data: MentionableUserFragment;
}
export const DisplayTemplate: React.FC<IDisplayTemplateProps> = ({ data }) => {
  return (
    <span style={{ color: "blue" }} data-mention-email={data.employee?.email}>
      @
      {data.employee
        ? getEmployeeDisplayName(data.employee)
        : "UnknownEmployee"}
    </span>
  );
};
